module.exports = __webpack_public_path__ + "static/media/DemoSummaryImage.911300f4.png";